import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { SeFeChipModule } from 'se-fe-chip'
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options'
import { SeFeListModule } from 'se-fe-list'
import { SeFeMenuModule } from 'se-fe-menu'
import { SeFeToolbarModule } from 'se-fe-toolbar'
import { OpenRegistrationFilterComponent } from './open-registration-filter/open-registration-filter.component'
import { OpenRegistrationSearchComponent } from './open-registration-search/open-registration-search.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SeFeChipModule,
    SeFeFormFieldOptionsModule,
    SeFeListModule,
    SeFeMenuModule,
    SeFeToolbarModule,
    TranslateModule,
  ],
  declarations: [
    OpenRegistrationFilterComponent,
    OpenRegistrationSearchComponent,
  ],
  exports: [
    OpenRegistrationFilterComponent,
    OpenRegistrationSearchComponent,
  ],
})
export class SeRegistrationUiFeatureOpenRegistrationListModule {}
